module.exports = __webpack_public_path__ + "img/motor-pump-solid-icon.40a86b23.svg";